var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-descriptions",
        { attrs: { column: 3 } },
        [
          _c("el-descriptions-item", { attrs: { label: "订单状态" } }, [
            _vm._v(_vm._s(_vm.info.stateStr)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "联系电话" } }, [
            _c(
              "div",
              { class: !_vm.isOpenSet ? "flex" : "flex flex-col" },
              [
                _vm.userList.includes(_vm.info.senderMobilePhone)
                  ? _c("yd-link", {
                      attrs: {
                        permi: "user_center_manage",
                        value: _vm.info.senderMobilePhone,
                        url: _vm.phoneUrl(_vm.info, _vm.info.senderMobilePhone),
                        type: "userInfo",
                        need: true,
                      },
                    })
                  : _c("span", [_vm._v(_vm._s(_vm.info.senderMobilePhone))]),
                !_vm.isOpenSet
                  ? _c(
                      "span",
                      { staticStyle: { "padding-left": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["order_intercity_editPhone"],
                                expression: "['order_intercity_editPhone']",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.handleOpenSet },
                          },
                          [_vm._v("修改电话")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isOpenSet
                  ? _c(
                      "span",
                      [
                        _c("el-input", {
                          staticStyle: { width: "150px", padding: "0 3px" },
                          attrs: {
                            clearable: "",
                            placeholder: "请输入电话号码",
                            maxlength: "11",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.newMobile,
                            callback: function ($$v) {
                              _vm.newMobile = $$v
                            },
                            expression: "newMobile",
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: { click: _vm.phoneCancel },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: { click: _vm.submit },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "下单人电话" } },
            [
              _vm.userList.includes(_vm.info.mobilePhone)
                ? _c("yd-link", {
                    attrs: {
                      permi: "user_center_manage",
                      value: _vm.info.mobilePhone,
                      url: _vm.phoneUrl(_vm.info, _vm.info.mobilePhone),
                      type: "userInfo",
                      need: true,
                    },
                  })
                : _c("span", [_vm._v(_vm._s(_vm.info.mobilePhone))]),
            ],
            1
          ),
          _c("el-descriptions-item", { attrs: { label: "关联改签订单号" } }, [
            _vm._v("--"),
          ]),
          _c("el-descriptions-item", { attrs: { label: "优惠券/活动名称" } }, [
            _vm._v("--"),
          ]),
          _c("el-descriptions-item", { attrs: { label: "抵扣金额" } }, [
            _vm._v("--"),
          ]),
          _c("el-descriptions-item", { attrs: { label: "订票来源" } }, [
            _vm._v(_vm._s(_vm.info.buyChannelStr)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "乘客备注" } }, [
            _vm._v(_vm._s(_vm.info.remarksPassenger || "--")),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "后台备注", span: "2" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("sapn", [
                    _vm._v(_vm._s(_vm.info.remarksBackstage || "--")),
                  ]),
                  !_vm.isOpenRemark
                    ? _c(
                        "span",
                        { staticStyle: { "padding-left": "10px" } },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["order_intercity_setRemark"],
                                  expression: "['order_intercity_setRemark']",
                                },
                              ],
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.openBtn },
                            },
                            [_vm._v("设置备注\n          ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isOpenRemark
                    ? _c(
                        "sapn",
                        { staticStyle: { "padding-left": "10px" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "20vw" },
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              placeholder: "请输入备注",
                            },
                            model: {
                              value: _vm.newRemark,
                              callback: function ($$v) {
                                _vm.newRemark = $$v
                              },
                              expression: "newRemark",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.remarkCancel },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", size: "mini" },
                              on: { click: _vm.sumitRemark },
                            },
                            [_vm._v("确定")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: "拒件说明", span: "3" } },
            [
              _c("div", [
                _c("div", [_vm._v(_vm._s(_vm.info.remarksDriver || "-"))]),
                _vm.info.remarksDriverImg
                  ? _c(
                      "div",
                      { staticClass: "flex-start" },
                      _vm._l(
                        _vm.info.remarksDriverImg.split(","),
                        function (item) {
                          return _c(
                            "div",
                            { key: item, staticClass: "margin-right-10" },
                            [
                              _c("el-image", {
                                staticStyle: { width: "50px", height: "50px" },
                                attrs: {
                                  src: item,
                                  "preview-src-list":
                                    _vm.info.remarksDriverImg.split(","),
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }